import { FeedItem } from '../../../types/feed.types';
import Card from '../card';
import { SocialCardBody } from './feed-card/body.feedCard';
import { Citation, SocialCardFooter } from './feed-card/footer.feedCard';
import { SocialCardHeader } from './feed-card/header.feedCard';

type FeedCardProps = {
  data: FeedItem;
};

const styles = {
  container:
    'min-w-[100%] w-full min-h-[185px] border rounded-xl border-light-gray social-card',
  header: 'px-3 pt-3 rounded-t-xl bg-[#1C1C1E59] backdrop-blur-lg rounded-t-xl',
  body: 'px-3 py-5 bg-[#1C1C1E59] backdrop-blur-lg shadow-card-body',
  footer:
    'px-3 py-3 bg-[#1C1C1E80] backdrop-blur-lg border-t border-light-gray rounded-b-xl',
};

export default function SocialCard(props: FeedCardProps) {
  const { data } = props;
  return (
    <div className="w-full">
      <Card className={styles.container}>
        <Card.Header className={styles.header}>
          <SocialCardHeader
            avatarUrl={data.avatar}
            username={data.username}
            tags={data.tags}
            daysAgo={data.date}
            verified={data.verified || false}
            isInternal={data.type === 'internal'}
            sourceUrl={data.sourceUrl}
            id={data.id}
          />
        </Card.Header>
        <Card.Body className={styles.body}>
          <SocialCardBody
            comment={data.comment || ''}
            mediaItem={data.mediaItem}
            imageUrl={data.imageUrl}
            link={data.link}
            type={data.type}
          />
        </Card.Body>
        <Card.Footer className={styles.footer}>
          <SocialCardFooter
            id={data.id}
            externalLink={data.link}
            type={data.type}
            reaction={data.reaction}
            isBookmarked={data.bookmarked || false}
          />
        </Card.Footer>
      </Card>
      {data.source !== 'holdr' && <Citation text={data.source} />}
    </div>
  );
}
